export const isAdminApproved = 'Is admin approved';
export const toggleLabel = 'toggle if admin has approved';
export const errorUpdatingToggle = (message) => `Error updating: ${message}`;
export const updateToggleSuccess = (message) => `Successfully updated: ${message}!`;
